import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

export const ErrorBox: any = styled(Box)`
    width: 100%;
    display: flex;
    //  height: 54px;
    align-items: center;
    justify-content: center;
    color: #790000;
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 25px;
    border-top: 2px solid #790000;
    border-bottom: 2px solid #790000;
    padding: 16px 0 16px 0;
    clear: both;
    text-align: center;
`;
